import { FormElement } from '../form-element.model';
import { FormElementProfileField } from './form-element-profile-field.model';

export class FormElementProfile extends FormElement {
  // #region Properties

  public OrgName: FormElementProfileField;
  public FirstName: FormElementProfileField;
  public LastName: FormElementProfileField;
  public MiddleInitial: FormElementProfileField;
  public Prefix: FormElementProfileField;
  public Suffix: FormElementProfileField;
  public Title: FormElementProfileField;
  public Address1: FormElementProfileField;
  public Address2: FormElementProfileField;
  public City: FormElementProfileField;
  public State: FormElementProfileField;
  public Zip: FormElementProfileField;
  public ZipExt: FormElementProfileField;
  public County: FormElementProfileField;
  public Country: FormElementProfileField;
  public WorkPhone: FormElementProfileField;
  public HomePhone: FormElementProfileField;
  public CellPhone: FormElementProfileField;
  public Ext: FormElementProfileField;
  public Fax: FormElementProfileField;
  public Email: FormElementProfileField;
  public BillingContact: FormElementProfileField;
  public ReceivesCommunication: FormElementProfileField;
  public RelationTypeToMember: FormElementProfileField;
  public OrgInd: boolean;

  // #endregion

  public constructor(isOrg?: boolean) {
    super();

    this.OrgInd = isOrg ?? false;
    this.ElementTypeId = isOrg ? 19 : 9;
    this.initialize();
  }

  public initialize(): void {
    this.OrgName = new FormElementProfileField();
    this.FirstName = new FormElementProfileField();
    this.LastName = new FormElementProfileField();
    this.MiddleInitial = new FormElementProfileField();
    this.Prefix = new FormElementProfileField();
    this.Suffix = new FormElementProfileField();
    this.Title = new FormElementProfileField();
    this.Address1 = new FormElementProfileField();
    this.Address2 = new FormElementProfileField();
    this.City = new FormElementProfileField();
    this.State = new FormElementProfileField();
    this.Zip = new FormElementProfileField();
    this.ZipExt = new FormElementProfileField();
    this.County = new FormElementProfileField();
    this.Country = new FormElementProfileField();
    this.WorkPhone = new FormElementProfileField();
    this.HomePhone = new FormElementProfileField();
    this.CellPhone = new FormElementProfileField();
    this.Ext = new FormElementProfileField();
    this.Fax = new FormElementProfileField();
    this.Email = new FormElementProfileField();
    this.BillingContact = new FormElementProfileField();
    this.ReceivesCommunication = new FormElementProfileField();
    this.RelationTypeToMember = new FormElementProfileField();

    this.OrgName.LabelText = 'Organization Name';
    this.FirstName.LabelText = 'First Name';
    this.LastName.LabelText = 'Last Name';
    this.MiddleInitial.LabelText = 'Middle Initial';
    this.Prefix.LabelText = 'Prefix';
    this.Suffix.LabelText = 'Suffix';
    this.Title.LabelText = 'Title';
    this.Address1.LabelText = 'Address1';
    this.Address2.LabelText = 'Address2';
    this.City.LabelText = 'City';
    this.State.LabelText = 'State';
    this.Zip.LabelText = 'Zip';
    this.ZipExt.LabelText = 'Zip Ext';
    this.County.LabelText = 'County';
    this.Country.LabelText = 'Country';
    this.WorkPhone.LabelText = 'Work Phone';
    this.HomePhone.LabelText = 'Home Phone';
    this.CellPhone.LabelText = 'Cell Phone';
    this.Ext.LabelText = 'Ext';
    this.Fax.LabelText = 'Fax';
    this.Email.LabelText = 'Email';
    this.BillingContact.LabelText = 'Billing Contact';
    this.ReceivesCommunication.LabelText = 'Receives Communication';
    this.RelationTypeToMember.LabelText = 'Relation Type to Member';

    this.FirstName.Visible = !this.OrgInd;
    this.LastName.Visible = !this.OrgInd;
    this.Email.Visible = true;
  }
}
